import { Component, OnInit } from '@angular/core';
import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';

import { AllListLabelValue, ListItem } from '../models/liste.model';
import { Pack } from '../models/pack.model';
import { environment } from "environments/environment";
import { lastValueFrom } from 'rxjs';
 let __URL_API__  = `${environment.URL_API}`; 

 @Injectable({providedIn: 'root'})
 export class ListeService {

    constructor(private _http: HttpClient) {
    }
    
    async getListeNature(): Promise<ListItem[]> {
        return this.getListe('ListeNatureIncident');
    }

    async getListeTheme(): Promise<ListItem[]> {
        return this.getListe('ListeThemeIncident');
    }

    async getListeSetvice(): Promise<ListItem[]> {
        return this.getListe('ListeServiceContact');
    }

    async getListeFonction(): Promise<ListItem[]> {
        return this.getListe('ListeFonctionContact');
    }

    async getListeGenre(): Promise<ListItem[]> {
        return this.getListe('ListeGenreContact');
    }

    async getListePays(): Promise<ListItem[]> {
        return this.getListe('ListePays');
    }

    async getListeAnneeExerciceComptable(): Promise<ListItem[]> {
        return this.getListe('ListeAnneeExerciceComptable');
    }

    async getListePack(): Promise<Pack[]> {
        try {
            let response = await this._http.get(__URL_API__ + 'api/FichePartenaire/GetListePacks').toPromise();
            return response as Array<Pack>;
        } catch (error) {
            return await this.handleError(error);
        }
    }

    private async getListe(typeListe: string): Promise<ListItem[]> {
        try {
            let response = await this._http.get(__URL_API__ + 'api/Liste/' + typeListe).toPromise();
            return response as Array<ListItem>;
        } catch (error) {
            return await this.handleError(error);
        }
    }

    async getAllLists(): Promise<AllListLabelValue> {
        try {
            const response = await lastValueFrom(this._http.get<AllListLabelValue>(__URL_API__ + 'api/liste'));
            return response;
        } catch (error) {
            return await this.handleError(error);
        }
    }

    private handleError(error: any): Promise<any> {
        return Promise.reject(error.message || error);
    }
}